// Competition type presets with their required date fields
export const COMPETITION_TYPE_PRESETS = {
    olympiad: {
        label: 'Olympiad',
        dates: [
            { key: 'register_date', label: 'Register Date', optional: true },
            { key: 'test_date', label: 'Test Date' }
        ]
    },
    amc: {
        label: 'AMC',
        dates: [
            { key: 'test_date', label: 'Test Date' },
            { key: 'register_date', label: 'Register Date', optional: true }
        ]
    },
    test: {
        label: 'Test',
        dates: [
            { key: 'register_date', label: 'Register Date', optional: true },
            { key: 'test_date', label: 'Test Date' }
        ]
    },
    wc: {
        label: 'WC',
        dates: [
            { key: 'register_date', label: 'Register Date', optional: true },
            { key: 'submit_date', label: 'Submit Date' }
        ]
    },
    research: {
        label: 'Research',
        dates: [
            { key: 'fair_date', label: 'Fair Date' },
            { key: 'register_date', label: 'Register Date', optional: true },
            { key: 'first_submit_date', label: 'First Submit Date', canDisable: true },
            { key: 'final_submit_date', label: 'Final Submit Date' }
        ]
    },
    manual: {
        label: 'Manual',
        dates: [] // Admin selects from AVAILABLE_DATE_TYPES
    }
};

// Available date types for manual selection
export const AVAILABLE_DATE_TYPES = [
    { key: 'register_date', label: 'Register Date', optional: true },
    { key: 'test_date', label: 'Test Date' },
    { key: 'submit_date', label: 'Submit Date' },
    { key: 'fair_date', label: 'Fair Date' },
    { key: 'first_submit_date', label: 'First Submit Date' }
];

// Get date config for a competition type
export const getDateConfigForType = (type) => {
    if (!type || !COMPETITION_TYPE_PRESETS[type]) {
        return [];
    }
    return [...COMPETITION_TYPE_PRESETS[type].dates];
};
